<template>
  <div class="label-item">
    <span class="label" v-if="label != ''">{{label}}</span>
    <span class="text">{{text}}</span>
  </div>
</template>

<script>
export default {
  name: 'LabelItem',

  props: {
    label: {
      type: String,
    },
    text: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.label-item{
  display: flex;
  flex-direction: column;
  text-align: left;
  .label{
    font-family: $notoSans;
    font-size: 14px;
    line-height: 23.4px;
    color: $black;
  }
  .text{
    background-color: #f5f5f5;
    border: 1px solid #ccc;;
    margin-top: 5px;
    font-family: $notoSans;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.8;
    color: #666;
    border-radius: 8px;
    padding: 4px 10px;
    min-height: 40px;
  }
}
</style>
